<template>
    <div class="cancel-meeting">
        <header
            class="d-flex align-items-center justify-content-between mb-0 fw-bold cancel-event-header bg-white font-size-lg"
        >
            Cancel Event
        </header>
        <section v-if="isRecurringEvent" class="d-flex align-items-center cancel-warning my-2 mx-3 font-size-xs">
            <i class="fas fa-info-circle text-secondary ms-2 me-2"></i>
            <div v-if="isCancelSeries">You're cancelling this and all the following events in this series.</div>
            <template v-else>
                <div>You're cancelling this event in the series</div>
                <button
                    type="button"
                    class="cancel-series-btn fw-semibold ms-auto bg-white"
                    @click="isCancelSeries = true"
                >
                    Cancel entire series
                </button>
            </template>
        </section>

        <div class="px-3 pb-2 mt-2 font-size-sm">Cancel this event and notify all participants.</div>

        <div class="px-3">
            <textarea
                class="form-control"
                rows="4"
                v-model="optionalMessage"
                placeholder="Type your message here (Optional)"
            ></textarea>
        </div>

        <footer class="d-flex justify-content-end p-3">
            <button type="button" class="btn btn-light border border-secondary me-2 bg-white" @click="cancel()">
                Dismiss
            </button>
            <button type="button" class="btn btn-danger" @click="submit()">Cancel</button>
        </footer>
    </div>
</template>

<script lang="ts" src="./CancelMeetingEvent.ts"></script>
<style scoped>
.cancel-meeting {
    width: 28rem;
    background: #f5f5f5;
}
.cancel-event-header {
    border-bottom: 1px solid #a2a2a2;
    padding: 0.5rem 1rem;
}

.cancel-warning {
    background-color: #eefbff;
    padding: 6px;
    border: 1px solid #bfbfbf;
    border-radius: 4px;
}

.cancel-series-btn {
    border: 1px solid #bfbfbf;
    border-radius: 4px;
    color: #d9534f;
}
</style>
